import XAPPService from "app/Core/services/XAPPService";
export const GET_FUNCIONALIDADE_TAG = "[FUNCIONALIDADE TAG APP] GET FUNCIONALIDADE TAG";
export const REMOVE_FUNCIONALIDADE_TAG = "[FUNCIONALIDADE TAG APP] REMOVE FUNCIONALIDADE TAG";
export const SAVE_FUNCIONALIDADE_TAG = "[FUNCIONALIDADE TAG APP] SAVE FUNCIONALIDADE TAG";
export const FUNCIONALIDADE_TAG_ERROR = "[FUNCIONALIDADE TAG APP] FUNCIONALIDADE TAG ERROR";
export const FUNCIONALIDADE_TAG_SELECIONAR_ERROR = "[FUNCIONALIDADE TAG APP] FUNCIONALIDADE TAG SELECIONAR ERROR";

const ListState =
    [
        "idtagpessoaformulario",
        "tagnome",
        "codigo",
    ];

export function list(_AAction, _AParams, _ATarget, _ACampo, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": _ATarget + "." + _ACampo, "Operador": "=", "Valor": Number.parseInt(_AID) }];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, _ATarget, AActions, "spvw" + _ATarget + "", ListState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_FUNCIONALIDADE_TAG,
                        name: _ATarget,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: FUNCIONALIDADE_TAG_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function SetTag(_AValue, _AParams, _ATarget, _ACampo, _AID) {
    return (dispatch) => {
        var AConditionsAND = [{ "Campo": _ACampo, "Operador": "=", "Valor": Number.parseInt(_AID) }];
        var AConditionsOR = [];
        var AActions = [];

        var obj = {};
        obj.idtagpessoaformulario = _AValue.idtagpessoaformulario;
        obj.idpessoa = _AParams.empresa;
        obj[_ACampo] = _AID;

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, _ATarget, "INSERIR", obj, "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then(() => {
                Promise.all([
                    dispatch({
                        type: SAVE_FUNCIONALIDADE_TAG
                    }),
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _ATarget, _ACampo, _AID)));
            }

            ).catch(error => {
                return dispatch({
                    type: FUNCIONALIDADE_TAG_ERROR,
                    payload: error
                });
            });
    };
}

export function RemoveTag(_AValue, _AParams, _ATarget, _ACampo, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": _ACampo, "Operador": "=", "Valor": Number.parseInt(_AID) }];
        var AConditionsOR = [];
        var AActions = [];

        if (_AValue.idtagpessoaformulario !== null) {
            AConditionsAND.push({ "Campo": "idtagpessoaformulario", "Operador": "=", "Valor": Number.parseInt(_AValue.idtagpessoaformulario) });
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, _ATarget, "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then(() =>
                Promise.all([
                    dispatch({
                        type: REMOVE_FUNCIONALIDADE_TAG
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _ATarget, _ACampo, _AID)))
            )
            .catch(error => {
                return dispatch({
                    type: FUNCIONALIDADE_TAG_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_FUNCIONALIDADE_TAG,
        name: null,
        payload: null
    };
}